$('#share').on('click', () => {
  $('.share-options').toggleClass('is-hidden');
});
let currentUrl = $('#copy-url').data('current-url');
$('#copy-url').on('click', () => {
  navigator.clipboard.writeText(currentUrl)
  .then(() => {
    $('.share-options').toggleClass('is-hidden');
  })
  .catch(err => {
    $('.share-options').toggleClass('is-hidden');
  });
});
$('#share-mobile').on('click', () => {
  if (navigator.share) {
    navigator.share({
      title: 'Check out these cars I found on Bumper.com',
      url: currentUrl
    }).then(() => {
    })
    .catch(console.error);
  } else {
    $('.share-options').toggleClass('is-hidden');
  }
});
$("[data-acsb='trigger']").on('click', e => {
  const loaded = sessionStorage.getItem("acsb_loaded");
  if (loaded) {
    return;
  }
  sessionStorage.setItem('acsb_loaded', true);
  window.location.href = window.location.href + "#showacsb";
  document.location.reload();
});


$('.tab').on('click', (e) => {
  let target = $(e.currentTarget).attr('data-target');
  openTab(e, target);
});

function openTab(evt, tabName) {
    var i, x, tablinks;
    x = document.getElementsByClassName("content-tab");
    for (i = 0; i < x.length; i++) {
        x[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tab");
    for (i = 0; i < x.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" is-active", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " is-active";
}


// Remove notification
$('.notification .delete').on('click', () => {
  $('.notification').remove();
});
